export const surveyData = [
  {
    id: 1,
    domain: "Communication",
    subcategories: [
      {
        id: 1,
        name: "Verbal Communication",
        questions: [
          { id: 1, text: "I clearly express my ideas and thoughts to others", subcategoryId: 1 },
          { id: 2, text: "I actively listen when others are speaking", subcategoryId: 1 }
        ]
      },
      {
        id: 2,
        name: "Written Communication",
        questions: [
          { id: 3, text: "I provide constructive feedback to team members", subcategoryId: 2 },
          { id: 4, text: "I communicate effectively in written form", subcategoryId: 2 }
        ]
      }
    ]
  },
  {
    id: 2,
    domain: "Teamwork",
    subcategories: [
      {
        id: 3,
        name: "Collaboration",
        questions: [
          { id: 5, text: "I collaborate well with team members", subcategoryId: 3 },
          { id: 6, text: "I contribute to team goals and objectives", subcategoryId: 3 }
        ]
      },
      {
        id: 4,
        name: "Support & Respect",
        questions: [
          { id: 7, text: "I support my colleagues when they need help", subcategoryId: 4 },
          { id: 8, text: "I respect diverse perspectives and opinions", subcategoryId: 4 }
        ]
      }
    ]
  },
  {
    id: 3,
    domain: "Problem Solving",
    subcategories: [
      {
        id: 5,
        name: "Analysis",
        questions: [
          { id: 9, text: "I analyze problems systematically", subcategoryId: 5 },
          { id: 10, text: "I develop creative solutions to challenges", subcategoryId: 5 }
        ]
      },
      {
        id: 6,
        name: "Decision Making",
        questions: [
          { id: 11, text: "I make decisions based on data and evidence", subcategoryId: 6 },
          { id: 12, text: "I learn from mistakes and adapt my approach", subcategoryId: 6 }
        ]
      }
    ]
  },
  {
    id: 4,
    domain: "Time Management",
    subcategories: [
      {
        id: 7,
        name: "Planning",
        questions: [
          { id: 13, text: "I prioritize tasks effectively", subcategoryId: 7 },
          { id: 14, text: "I meet deadlines consistently", subcategoryId: 7 }
        ]
      },
      {
        id: 8,
        name: "Execution",
        questions: [
          { id: 15, text: "I manage my workload efficiently", subcategoryId: 8 },
          { id: 16, text: "I avoid procrastination", subcategoryId: 8 }
        ]
      }
    ]
  },
  {
    id: 5,
    domain: "Leadership",
    subcategories: [
      {
        id: 9,
        name: "Initiative",
        questions: [
          { id: 17, text: "I take initiative on projects", subcategoryId: 9 },
          { id: 18, text: "I motivate and inspire others", subcategoryId: 9 }
        ]
      },
      {
        id: 10,
        name: "Management",
        questions: [
          { id: 19, text: "I delegate tasks appropriately", subcategoryId: 10 },
          { id: 20, text: "I lead by example", subcategoryId: 10 }
        ]
      }
    ]
  }
];

export const ratingScale = [
  { value: -1, label: "Skip" },
  { value: 0, label: "Never" },
  { value: 1, label: "Rarely" },
  { value: 2, label: "Sometimes" },
  { value: 3, label: "Always" }
];
